/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { actions } from "../actions/UsersActions";
const initialState = {
  data: {
    groups: [],
    usersByGroupId: {},
    companionsByUserId: {},
  },
  isLoading: false,
  status: "INITIAL",
};

const GroupsReducer = (state = initialState, action) => {
  if (action.type === actions.GROUPS_LOADING) {
    return {
      ...state,
      status: "PENDING",
      isLoading: true,
    };
  }
  if (action.type === actions.GROUPS_SUCCESS) {
    return {
      data: {
        ...state.data,
        groups: action.payload,
      },
      status: "SUCCESS",
      isLoading: false,
    };
  }
  if (action.type === actions.GROUPS_FAILED) {
    return {
      ...state,
      status: "INITIAL",
      isLoading: false,
    };
  }
  if (action.type === actions.USERS_LOADING) {
    return {
      ...state,
      status: "PENDING",
      isLoading: true,
    };
  }
  if (action.type === actions.USERS_FAILED) {
    return {
      ...state,
      status: "INITIAL",
      isLoading: false,
    };
  }
  if (action.type === actions.USERS_SUCCESS) {
    return {
      data: {
        ...state.data,
        usersByGroupId: {
          ...state.data.usersByGroupId,
          [action.payload.groupId]: action.payload.users,
        },
      },
      status: "SUCCESS",
      isLoading: false,
    };
  }
  if (action.type === actions.COMPANIONS_LOADING) {
    return {
      ...state,
      status: "PENDING",
      isLoading: true,
    };
  }
  if (action.type === actions.COMPANIONS_SUCCESS) {
    return {
      data: {
        ...state.data,
        companionsByUserId: {
          ...state.data.companionsByUserId,
          [action.payload.userId]: action.payload.companions,
        },
      },
      status: "SUCCESS",
      isLoading: false,
    };
  }
  return state;
};

export default GroupsReducer;
